var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00376 9.94387C12.0777 9.94387 14.8606 8.22934 16.3557 5.52418C14.8606 2.81902 12.0777 1.10448 9.00376 1.10448C5.92979 1.10448 3.1469 2.81902 1.65183 5.52418C3.1469 8.22934 5.92979 9.94387 9.00376 9.94387ZM9.00376 0.190063C12.6675 0.190063 15.8406 2.36029 17.3859 5.52418C15.8406 8.68807 12.6675 10.8583 9.00376 10.8583C5.33999 10.8583 2.16695 8.68807 0.621582 5.52418C2.16695 2.36029 5.33999 0.190063 9.00376 0.190063ZM9.00376 7.65782C9.56964 7.65782 10.1123 7.43303 10.5125 7.03289C10.9126 6.63276 11.1374 6.09006 11.1374 5.52418C11.1374 4.9583 10.9126 4.4156 10.5125 4.01546C10.1123 3.61533 9.56964 3.39053 9.00376 3.39053C8.43788 3.39053 7.89518 3.61533 7.49505 4.01546C7.09491 4.4156 6.87012 4.9583 6.87012 5.52418C6.87012 6.09006 7.09491 6.63276 7.49505 7.03289C7.89518 7.43303 8.43788 7.65782 9.00376 7.65782ZM9.00376 8.57224C8.19536 8.57224 7.42008 8.25111 6.84845 7.67949C6.27683 7.10786 5.9557 6.33258 5.9557 5.52418C5.9557 4.71578 6.27683 3.94049 6.84845 3.36887C7.42008 2.79725 8.19536 2.47611 9.00376 2.47611C9.81216 2.47611 10.5874 2.79725 11.1591 3.36887C11.7307 3.94049 12.0518 4.71578 12.0518 5.52418C12.0518 6.33258 11.7307 7.10786 11.1591 7.67949C10.5874 8.25111 9.81216 8.57224 9.00376 8.57224Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3672b8f050f00b1d6148ab9eacc43886.svg";
export { ForwardRef as ReactComponent };